import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration
import MenuView from 'jet-views/menu'; // Importing MenuView component
import ToolView from 'jet-views/toolbar'; // Importing ToolView component

/**
 * Class representing the products view.
 * @extends JetView
 */
export default class productsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'x', // Horizontal scrolling enabled
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for inner layout
                            gravity: 4, // Gravity for layout distribution
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tabbar component
                                    localId: 'tabbar', // Local identifier for tabbar
                                    ccs: 'tabbar-custom', // Custom CSS class for tabbar
                                    optionWidth: 130, // Width of each tab option
                                    height: screen == 'small' ? 75 : 65, // Height based on screen size
                                    options: [
                                        {
                                            id: 'partner.products2.partnersProducts', // Unique identifier for the tab
                                            value: _('Activacion Productos'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Products', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Products', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersProviders', // Unique identifier for the tab
                                            value: _('Partners Proveedores'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Providers', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Providers', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.enablementProducts', // Unique identifier for the tab
                                            value: _('Habilitacion productos'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction(
                                                'partnerProducts2EnablementProducts',
                                                'Add',
                                            ), // Visibility based on permission
                                            css: 'prm-partnerProducts2Providers', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersSubProviders', // Unique identifier for the tab
                                            value: _('Partners Sub Proveedores'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2SubProviders', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2SubProviders', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersSubProvidersOrder', // Unique identifier for the tab
                                            value: _('Partners Sub Proveedores Orden'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction(
                                                'partnerProducts2SubProvidersOrder',
                                                'Add',
                                            ), // Visibility based on permission
                                            css: 'prm-partnerProducts2SubProvidersOrder', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersCredentialsSubProviders', // Unique identifier for the tab
                                            value: _('Credenciales Por Sub Proveedor'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction(
                                                'partnerProducts2SCredentialsSubProviders',
                                                'Add',
                                            ), // Visibility based on permission
                                            css: 'prm-partnerProducts2CredentialsSubProviders', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersTypeProduct', // Unique identifier for the tab
                                            value: _('Partners Tipo'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2TypeProduct', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2TypeProduct', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.categoriesProducts', // Unique identifier for the tab
                                            value: _('Categorías Productos'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction(
                                                'partnerProducts2CategoriesProducts',
                                                'Add',
                                            ), // Visibility based on permission
                                            css: 'prm-partnerProducts2CategoriesProducts', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersCategories', // Unique identifier for the tab
                                            value: _('Partners Categorías'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Categories', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Categories', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersGames', // Unique identifier for the tab
                                            value: _('Ordenar Juegos'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Games', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Games', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersBanks', // Unique identifier for the tab
                                            value: _('Banco Pais'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Banks', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Banks', // CSS class for styling
                                        },
                                        {
                                            id: 'partner.products2.partnersFranchises', // Unique identifier for the tab
                                            value: _('Partners Franquicias'), // Localized label for the tab
                                            hidden: !devConfig.getPermAction('partnerProducts2Franchises', 'Add'), // Visibility based on permission
                                            css: 'prm-partnerProducts2Franchises', // CSS class for styling
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and its plugins.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Using Menu plugin with the tabbar
    }
}

// FILE DOCUMENTED
